export default "__VITE_ASSET__Bw235goN__"